import { useTranslation } from '@helios/frontend-core';
import { PalmettoIcon } from '@palmetto/dsm-components';

export const SavingsExplainerContent = () => {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col gap-40 items-center"
      data-testid="savings-explainer-content"
    >
      <h2 className="sr-only" data-testid="savings-explainer-title">
        {t('electricityUsageOrSolarPage.savingsExplainer.titleA11y')}
      </h2>
      <div
        aria-hidden="true"
        className="flex flex-col items-center pb-16 w-full"
        data-testid="savings-explainer-title-visual"
      >
        <div className="flex flex-col gap-10 items-end pb-12">
          <span className="body-stylized-600 text-text-tertiary whitespace-nowrap">
            {t('electricityUsageOrSolarPage.savingsExplainer.titleCostLine')}
          </span>
          <div className="flex gap-10 items-start justify-end w-full body-stylized-600 whitespace-nowrap">
            <span className="text-text-tertiary">–</span>
            <span className="text-primary-500">
              {t('electricityUsageOrSolarPage.savingsExplainer.titleCurrentCostsLine')}
            </span>
          </div>
          <div className="h-[3px] w-full bg-border-default" />
          <span className="body-stylized-600 text-text-success whitespace-nowrap">
            {t('electricityUsageOrSolarPage.savingsExplainer.titleSavingsLine')}
          </span>
        </div>
      </div>
      <div className="flex flex-col gap-32 items-start w-full">
        <div className="flex flex-col gap-10 items-start w-full">
          <PalmettoIcon
            aria-hidden="true"
            name="powerPlantGridUtility"
            size="xl"
            className="text-icon-primary"
          />
          <p
            className="body-stylized-600 text-text-secondary w-full"
            data-testid="savings-explainer-utility"
            dangerouslySetInnerHTML={{
              __html: t('electricityUsageOrSolarPage.savingsExplainer.definitionUtility'),
            }}
          />
        </div>
        <div className="flex flex-col gap-10 items-start w-full">
          <PalmettoIcon
            aria-hidden="true"
            name="sunny"
            size="xl"
            className="text-icon-primary"
          />
          <p
            className="body-stylized-600 text-text-secondary w-full"
            data-testid="savings-explainer-solar"
            dangerouslySetInnerHTML={{
              __html: t('electricityUsageOrSolarPage.savingsExplainer.definitionSolar'),
            }}
          />
        </div>
        <div className="flex flex-col gap-10 items-start w-full">
          <PalmettoIcon
            aria-hidden="true"
            name="saveMoneyPiggyBank"
            size="xl"
            className="text-icon-primary"
          />
          <p
            className="body-stylized-600 text-text-secondary w-full"
            data-testid="savings-explainer-savings"
            dangerouslySetInnerHTML={{
              __html: t('electricityUsageOrSolarPage.savingsExplainer.definitionSavings'),
            }}
          />
        </div>
      </div>

      <p
        className="body-300 italic text-text-tertiary w-full"
        data-testid="savings-explainer-disclaimer"
      >
        {t('electricityUsageOrSolarPage.savingsExplainer.disclaimer')}
      </p>
    </div>
  );
};

export default SavingsExplainerContent;
